'use client'

import stylesButtonBase from '@fukku/button/Base/ButtonBase.module.css'
import { BUTTON_VARIANT } from '@fukku/button/Button.types'
import stylesPrimaryButton from '@fukku/button/Primary/ButtonPrimary.module.css'
import { cx } from 'classix'
import type { ReactNode } from 'react'
import { ClientLink } from 'utils/link/client/ClientLink'
import type { ButtonClientLinkProps } from '../ButtonClientLink.types'
import styles from './ClientLinkPrimary.module.css'

export function ClientLinkPrimary(props: ButtonClientLinkProps): ReactNode {
	const {
		children,
		variant = BUTTON_VARIANT.DEFAULT,
		className,
		fullWidth,
		...rest
	} = props

	return (
		<ClientLink
			{...rest}
			className={cx(
				className,
				styles.link,
				stylesButtonBase.button,
				stylesPrimaryButton[variant],
				fullWidth && stylesButtonBase.fullWidth
			)}
		>
			<span className={styles.content}>{children}</span>
		</ClientLink>
	)
}
